import { inject } from 'aurelia-framework';
import { HttpClient } from 'aurelia-http-client';

@inject(HttpClient)
export class WhiteLabelAPI {
  constructor(http) {
    this.http = http;
  }

  create(data, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
        x.withHeader('Content-Type', 'application/json');
    });


    this.http.post('api/whitelabel/signup', data)
        .then(data => {

            if (data.isSuccess) {
                if (data.response) {
                    var json = JSON.parse(data.response);

                    if (json.hasOwnProperty("whitelabel_id")) {
                       
                        successCallback(json.whitelabel_id);
                    }


                    if (json.hasOwnProperty("error"))
                        errorCallback(json.error);
                } else
                    successCallback();

            }
            else {
                errorCallback(data.statusText);
            }
        });
  }

  getWLSignupParams(successCallback, errorCallback) {
    this.http = this.http.configure(x => {
        x.withHeader('Content-Type', 'application/json');

    });

    this.http.get('api/whitelabel/getWLSignupParams ')
        .then(data => {

            if (data.isSuccess) {
                var json = JSON.parse(data.response);

                if (json.hasOwnProperty("key") && json.hasOwnProperty("redirect_url"))
                    successCallback(json.key, json.redirect_url,json.starter_base_fee,json.starter_per_user_fee,json.unlimited_base_fee,json.recaptcha_site_key);

                if (json.hasOwnProperty("error"))
                    errorCallback(json.error);

            }
            else {
                errorCallback(data.statusText);
            }
        });

}


isWLRFlagEnabled(data, successCallback, errorCallback) {
    this.http = this.http.configure(x => {
        x.withHeader('Content-Type', 'application/json');
    });

    this.http.post('api/wlusers/isWLRFlagEnabled', data)
        .then(data => {
            
            if (data.isSuccess) {
                if (data.response) {
                    var json = JSON.parse(data.response);
                    successCallback(json.result);
                    if (json.hasOwnProperty("error"))
                        errorCallback(json.result);
                } else
                    successCallback();

            }
            else {
                errorCallback(data.statusText);
            }
        });
  }

}
